// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"modal-footer_modalFooter__1-IC2"};